/* global slideUp, slideDown, attachEvent */
// **************************************************
// Accordion toggle
// **************************************************

function closeFaqItems() {
  const faqItems = document.querySelectorAll('.accordion__item');
  faqItems.forEach((elem) => {
    if (elem.classList.contains('is-open')) {
      const faqItemContent = elem.querySelectorAll('.accordion__item__content')[0];
      elem.classList.remove('is-open');
      slideUp(faqItemContent, 300);
    }
  });
}

attachEvent('.accordion__item__title', 'click', (ev) => {
  // ev.preventDefault();

  const faqItem = ev.target.closest('.accordion__item');
  const faqItemContent = faqItem.querySelectorAll('.accordion__item__content')[0];

  if (faqItem.classList.contains('is-open')) {
    closeFaqItems();
  } else {
    closeFaqItems();
    faqItem.classList.add('is-open');
    slideDown(faqItemContent, 300);
  }
});

// *************************************************************
// Scroll To Section
// *************************************************************

const getOffsetTop = (element) => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    // eslint-disable-next-line no-param-reassign
    element = element.offsetParent;
  }
  return offsetTop;
};

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', (ev) => {
    if (ev.target.hash) {
      const topOffset = getOffsetTop(document.querySelector(ev.target.hash));

      if (headerEle) {
        const topOffsetSection = topOffset - headerEle.offsetHeight;
        scrollToSmoothly(topOffsetSection);
      }
    }
  });
});
